import PropTypes from 'prop-types';
import React, { useState } from 'react';

const ChooseMembership = ({
  membershipProducts,
  selectedMembershipProduct,
  selectedMembershipProductChanged
}) => {
  const [selectedCadences, setSelectedCadences] = useState({});

  const isSelected = (product) => {
    return selectedMembershipProduct && selectedMembershipProduct.id === product.id;
  };

  const hasBothCadences = (product) => {
    return product.ticketing_price && product.ticketing_monthly_price;
  };

  const getSelectedCadence = (product) => {
    if (selectedCadences[product.id]) return selectedCadences[product.id];
    if (!product.ticketing_price && product.ticketing_monthly_price) return "month";
    return "year";
  };

  const getActivePrice = (product) => {
    const cadence = getSelectedCadence(product);
    if (cadence === "month" && product.ticketing_monthly_price) {
      return product.ticketing_monthly_price;
    }
    return product.ticketing_price || product.ticketing_monthly_price;
  };

  const handleCadenceChange = (product, cadence) => {
    setSelectedCadences(prev => ({ ...prev, [product.id]: cadence }));
    if (isSelected(product)) {
      const price = cadence === "month" && product.ticketing_monthly_price
        ? product.ticketing_monthly_price
        : product.ticketing_price;
      selectedMembershipProductChanged({ ...product, ticketing_price: price });
    }
  };

  const handleQuantityChange = (product, quantity) => {
    if (parseInt(quantity) === 1) {
      const price = getActivePrice(product);
      selectedMembershipProductChanged({ ...product, ticketing_price: price });
    } else {
      selectedMembershipProductChanged(null);
    }
  };

  return (
    <div>
      <p className="mb-3 font-weight-bold" style={{ fontSize: "16px", color: "#1a1a1a" }}>
        Membership Options
      </p>
      {membershipProducts.map((product) => {
        const price = getActivePrice(product);
        const selected = isSelected(product);
        const hasExisting = product.existing_membership != null;
        const hasBoth = hasBothCadences(product);

        return (
          <div key={product.id}
               className="bg-light rounded p-3 mb-3">
            <div className="d-flex justify-content-between align-items-start"
                 style={{ marginBottom: (product.benefits && product.benefits.length > 0) || hasBoth ? "16px" : "0" }}>
              <div>
                <h4 className="font-weight-bold mb-0" style={{ fontSize: "16px", color: "#1a1a1a" }}>
                  {product.name}
                </h4>
                <p className="mb-0 text-muted" style={{ fontSize: "14px" }}>
                  {price ? price.price_to_currency : ""}
                  {price && price.interval_label ? `/${price.interval_label}` : ""}
                </p>
                {product.description && product.description.length > 0 ? (
                  <p className="mb-0 text-secondary mt-1" style={{ fontSize: "14px" }}>
                    {product.description}
                  </p>
                ) : null}
              </div>
              {hasExisting ? (
                <div className="d-flex align-items-center" style={{ height: "40px" }}>
                  <span className="badge badge-success px-3 py-2" style={{ fontSize: "13px", borderRadius: "20px" }}>
                    <i className="fas fa-check-circle mr-1"></i>
                    Active Member
                  </span>
                </div>
              ) : (
                <select
                  className="form-control"
                  style={{ width: "70px", height: "40px" }}
                  value={selected ? "1" : "0"}
                  onChange={(e) => handleQuantityChange(product, e.target.value)}
                >
                  <option value="0">0</option>
                  <option value="1">1</option>
                </select>
              )}
            </div>

            {hasBoth && !hasExisting && (
              <div className="d-flex mb-2" style={{ gap: "12px" }}>
                <label className="d-flex align-items-center mb-0" style={{ cursor: "pointer", fontSize: "14px" }}>
                  <input
                    type="radio"
                    name={`cadence-${product.id}`}
                    value="year"
                    checked={getSelectedCadence(product) === "year"}
                    onChange={() => handleCadenceChange(product, "year")}
                    className="mr-1"
                  />
                  Annual ({product.ticketing_price.price_to_currency}/year)
                </label>
                <label className="d-flex align-items-center mb-0" style={{ cursor: "pointer", fontSize: "14px" }}>
                  <input
                    type="radio"
                    name={`cadence-${product.id}`}
                    value="month"
                    checked={getSelectedCadence(product) === "month"}
                    onChange={() => handleCadenceChange(product, "month")}
                    className="mr-1"
                  />
                  Monthly ({product.ticketing_monthly_price.price_to_currency}/month)
                </label>
              </div>
            )}

            {product.benefits && product.benefits.length > 0 ? (
              <ul className="mb-0 pl-4 text-secondary" style={{ fontSize: "14px", lineHeight: "1.8" }}>
                {product.benefits.map((benefit) => (
                  <li key={benefit.id}>{benefit.description}</li>
                ))}
              </ul>
            ) : null}
          </div>
        );
      })}
    </div>
  );
};

ChooseMembership.propTypes = {
  membershipProducts: PropTypes.array.isRequired,
  selectedMembershipProduct: PropTypes.object,
  selectedMembershipProductChanged: PropTypes.func.isRequired
};

export default ChooseMembership;
